var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useGetInboundEmailsQuery, useGetModuleFieldsQuery, useGetModuleListQuery, useSaveInboundEmailSettingsMutation, } from "@/store/api";
import TuiGrid from "tui-grid";
import Grid from "@toast-ui/react-grid";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { tableOptions } from "@/components/widgets/module";
import copy from "fast-copy";
import { Pagination } from "@/components/dev/pagination";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
var InboundEmail = function () {
    var _a, _b;
    var t = useTranslation(["common", "InboundEmail", "Studio"]).t;
    var location = useLocation();
    var navigate = useNavigate();
    var params = new URLSearchParams(location.search);
    var typeSearch = params.get("type");
    var _c = useState(false), saving = _c[0], setSaving = _c[1];
    var fieldsAvailable = [
        { name: "name", label: "LBL_NAME", default: true },
        { name: "global_personal_string", label: "LBL_IS_PERSONAL", default: true },
        { name: "email_user", label: "LBL_LOGIN", default: true },
        { name: "server_url", label: "LBL_SERVER_URL", default: true },
        { name: "status", label: "LBL_STATUS", default: true },
    ];
    /*const [sortedParams, setSortedParams] = useState([
      {
        name: "date_entered",
        direction: "descending",
      },
    ]);*/
    var _d = useSaveInboundEmailSettingsMutation(), saveInboundEmailConfig = _d[0], _e = _d[1];
    var _f = useState({
        type: "case",
        macro: "",
    }), settings = _f[0], setSettings = _f[1];
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setSaving(true);
                    return [4 /*yield*/, saveInboundEmailConfig({
                            body: JSON.stringify(settings),
                        }).unwrap()];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    toast.error("Erreur lors de la sauvegarde ".concat(error_1));
                    return [3 /*break*/, 4];
                case 3:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var tuiref = useRef(null);
    var _g = useGetInboundEmailsQuery({ type: typeSearch }), dataEmail = _g.data, error = _g.error, isLoading = _g.isLoading;
    var recordsTotal = (_a = dataEmail === null || dataEmail === void 0 ? void 0 : dataEmail.data) === null || _a === void 0 ? void 0 : _a.total;
    var _h = useState("asc"), sortedParams = _h[0], setSortedParams = _h[1];
    var _j = useGetModuleListQuery({
        table: "InboundEmail",
        params: {
            sorted: sortedParams,
            where: "",
            page: 0,
            pageSize: recordsTotal,
            count: false,
        },
    }), moduleList = _j.data, refetch = _j.refetch, isFetching = _j.isFetching, isError = _j.isError;
    var NameRenderer = /** @class */ (function () {
        function NameRenderer(props) {
            this.el = document.createElement("span");
            this.props = props;
            this.render();
        }
        NameRenderer.prototype.getElement = function () {
            return this.el;
        };
        NameRenderer.prototype.render = function () {
            var _a = this.props, value = _a.value, rowKey = _a.rowKey, grid = _a.grid;
            this.el.innerHTML = "<span style=\"color: blue; cursor: pointer\">".concat(value, "</span>");
            this.el.onclick = function () {
                var row = grid === null || grid === void 0 ? void 0 : grid.getRow(rowKey);
                if (row === null || row === void 0 ? void 0 : row.id) {
                    navigate("/modules/InboundEmail/EditView/".concat(row.id));
                }
            };
        };
        NameRenderer.prototype.destroy = function () {
            this.el.onclick = null;
        };
        return NameRenderer;
    }());
    var realColsGrid = [
        {
            header: "Name",
            name: "name",
            width: 400,
            sortable: true,
            renderer: {
                type: NameRenderer, // ← une classe, accepté par TypeScript
            },
            /* formatter: ({ row, value }: any) => {
              if (!value) return "";
              const id = row.id; // ⚡ récupère l'id de la ligne
              return `<a href="/modules/InboundEmail/EditView/${id}"
                        style="color:blue; ">
                        ${value}
                      </a>`;
            },*/
        },
        {
            header: "Type",
            name: "global_personal_string",
            width: 300,
            sortable: true,
        },
        {
            header: "Mail Accounts User",
            name: "email_user",
            width: 300,
            sortable: true,
        },
        { header: "Server URL", name: "server_url", width: 400, sortable: true },
        { header: "Status", name: "status", width: 300, sortable: true },
    ];
    var _k = useState([]), dataTuiGrid = _k[0], setDataTuiGrid = _k[1];
    var divRef = useRef(null);
    var _l = useState(0), pageWidth = _l[0], setPageWidth = _l[1];
    var updateWidth = function () {
        if (divRef.current) {
            var width = divRef.current.getBoundingClientRect().width;
            setPageWidth(width);
        }
    };
    useEffect(function () {
        updateWidth();
        window.addEventListener("resize", updateWidth);
        return function () {
            window.removeEventListener("resize", updateWidth);
        };
    }, [divRef.current]);
    var listFields = useGetModuleFieldsQuery("InboundEmail" || "").data;
    var list = (_b = moduleList === null || moduleList === void 0 ? void 0 : moduleList.data) === null || _b === void 0 ? void 0 : _b.records;
    var _m = useState(copy(list)), newRecord = _m[0], setNewRecord = _m[1];
    var perPage = 4;
    var _o = useState(0), currentPage = _o[0], setCurrentPage = _o[1];
    var handlePagination = function (e) {
        setCurrentPage(e.selected);
    };
    function deepClone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    useEffect(function () {
        if (!list)
            return;
        var start = currentPage * perPage;
        var end = start + perPage;
        // ⚡ Cloner pour éviter les objets immuables
        setDataTuiGrid(deepClone(list.slice(start, end)));
    }, [list, currentPage]);
    var data = newRecord || [];
    useEffect(function () {
        if (tuiref.current) {
            var gridInstance = tuiref.current.getInstance();
            gridInstance.on("sort", function (ev) {
                var columnName = ev.columnName, ascending = ev.ascending;
                var sorted = deepClone(list).sort(function (a, b) {
                    var _a, _b;
                    var aValue = (_a = a[columnName]) !== null && _a !== void 0 ? _a : "";
                    var bValue = (_b = b[columnName]) !== null && _b !== void 0 ? _b : "";
                    if (aValue < bValue)
                        return ascending ? -1 : 1;
                    if (aValue > bValue)
                        return ascending ? 1 : -1;
                    return 0;
                });
                var start = currentPage * perPage;
                var end = start + perPage;
                setDataTuiGrid(sorted.slice(start, end));
            });
        }
    }, [tuiref, list, currentPage]);
    var sort = "<svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fas\" data-icon=\"sort\" class=\"svg-inline--fa fa-sort text-gray-500\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 320 512\"><path fill=\"currentColor\" d=\"M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z\"></path></svg>";
    var sortUp = "<svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fad\" data-icon=\"sort-up\" class=\"svg-inline--fa fa-sort-up text-gray-500\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 320 512\"><g class=\"fa-duotone-group\"><path class=\"fa-secondary\" fill=\"currentColor\" d=\"M0 320c0 8.3 3.3 16.5 9.4 22.6l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 288c-12.9 0-24.6 7.8-29.6 19.8C.8 311.7 0 315.9 0 320zm109.3 32l101.5 0L160 402.7 109.3 352z\"></path><path class=\"fa-primary\" fill=\"currentColor\" d=\"M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z\"></path></g></svg>";
    var sortDown = "<svg aria-hidden=\"true\" focusable=\"false\" data-prefix=\"fad\" data-icon=\"sort-down\" class=\"svg-inline--fa fa-sort-down text-gray-500\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 320 512\"><g class=\"fa-duotone-group\"><path class=\"fa-secondary\" fill=\"currentColor\" d=\"M0 192c0 4.1 .8 8.3 2.4 12.2c5 12 16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128C3.3 175.5 0 183.7 0 192zm109.3-32L160 109.3 210.7 160l-101.5 0z\"></path><path class=\"fa-primary\" fill=\"currentColor\" d=\"M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z\"></path></g></svg>";
    var rowHeight = 45;
    var bodyHeight = rowHeight * perPage;
    TuiGrid.applyTheme("default", tableOptions);
    /*const bodyHeight = useMemo(() => {
      const numberOfRows = dataTuiGrid?.length || 0;
      return Math.max(numberOfRows * 35, 100);
    }, [dataTuiGrid]);*/
    var gridWrapper = {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
    };
    if (isLoading)
        return _jsx("div", { children: "Loading..." });
    if (error)
        return _jsx("div", { children: "Error loading data" });
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "p-6 m-2 bg-[var(--colors-bg-default)] text-[--colors-label]  space-y-6  rounded-md" }, { children: [_jsx("h1", __assign({ className: "text-xl font-bold mb-4" }, { children: "Param\u00E8tres des Emails entrants -" })), _jsx("button", __assign({ onClick: handleSave, disabled: saving, className: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50" }, { children: t("LBL_BTN_SAVE", { ns: "Studio" }) })), _jsx("div", __assign({ className: "mb-6" }, { children: _jsx("table", __assign({ className: "w-full border border-gray-300 text-sm" }, { children: _jsx("tbody", { children: _jsxs("tr", __assign({ className: "border-b" }, { children: [_jsxs("td", __assign({ className: "p-3 w-1/5 font-bold bg-gray-50" }, { children: [t("LBL_CASE_MACRO", {
                                                ns: "InboundEmail",
                                            }), ":"] })), _jsx("td", __assign({ className: "p-3 w-1/4" }, { children: _jsx("input", { type: "text", value: settings.macro, placeholder: "[[CASE:%1]]", onChange: function (e) {
                                                return setSettings(__assign(__assign({}, settings), { macro: e.target.value }));
                                            }, className: "w-full p-2 border rounded-md" }) })), _jsxs("td", __assign({ className: "p-3 w-2/4 text-gray-600" }, { children: [t("LBL_CASE_MACRO_DESC", {
                                                ns: "InboundEmail",
                                            }), _jsx("br", {}), _jsx("i", __assign({ className: "text-gray-500" }, { children: t("LBL_CASE_MACRO_DESC2", {
                                                    ns: "InboundEmail",
                                                }) }))] }))] })) }) })) })), _jsx("div", __assign({ ref: divRef, className: "flex flex-col flex-1 py-4 bg-[var(--colors-subpanel-bg)]  border-2 border-gray-50\n  ", style: gridWrapper }, { children: _jsxs("div", { children: [_jsx("div", __assign({ className: "flex justify-end flex-1 h-8 items-center mb-2 " }, { children: _jsx(Pagination, { totalResult: list === null || list === void 0 ? void 0 : list.length, elementPerPage: perPage, currentPage: currentPage, onChangePagination: function (event) { return handlePagination(event); } }) })), _jsx("div", __assign({ className: "flex w-full flex-1 z-50" }, { children: dataTuiGrid && dataTuiGrid.length > 0 ? (_jsx(Grid, { ref: tuiref, bodyHeight: rowHeight * perPage, width: pageWidth, scrollX: true, columns: realColsGrid, data: dataTuiGrid })) : (_jsx("div", __assign({ className: "h-[100px] bg-[#f4f4ff] flex items-center justify-center w-full text-[rgb(var(--color-gray-500))]" }, { children: t("app.LBL_NO_DATA", {
                                        ns: "common",
                                    }) }))) }))] }) }))] })) }));
};
function paginate(array, page_size, page_number) {
    return array.slice((page_number - 1) * page_size, page_number * page_size);
}
export default InboundEmail;
